import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _CostingCenterHistory } from "../../../../../core/services/dataBean/EntityCatalogVdos";



interface Props {
    idAccount: number;
}

export const CostingCenterHistoryCatalog = ({ idAccount }: Props) => {

    const HistoryCatalog = useDataBean(_CostingCenterHistory);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idAccount])

    const getLista = () => {

        HistoryCatalog.instance.getCostingCenterHistoryCatalog(idAccount).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const create = () => {
        HistoryCatalog.setBean({
            IDAccount: idAccount
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        HistoryCatalog.deleteItemVoid(HistoryCatalog.bean.IDCostingCenterHistory).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        HistoryCatalog.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCostingCenterHistory', visible: true },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Fecha Desde', property: 'FromDate', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Actualiza', property: 'EmployeeName', visible: true },
        { title: 'Fecha actualización', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={HistoryCatalog.setBean} ></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={HistoryCatalog.bean.Name} onChange={HistoryCatalog.handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-12">
                            <label>Description</label>
                            <textarea name="Description" className="form-control" value={HistoryCatalog.bean.Description} onChange={HistoryCatalog.handleChange} />
                        </div>
                        {/* <PrintJson json={SubMacroProcess.bean} /> */}
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}